<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-md-8 col-lg-6 order-confirmation-page text-center">
                <h1 class="title mb-4" id="message">@lang('Redirecting to payment page...')</h1>
                <div class="plain-text">
                    <div class="d-none" id="simplepay-start-payment-form"></div>
                    <div class="mt-3 remove-on-error">
                        @lang('Please wait until the payment page loads')
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    name: 'RedirectToPayment',

    prop: {
        url: {
            type: String,
            required: true
        }
    },

    mounted() {
        setTimeout(this.startPayment, 5000);
    },

    methods: {
        startPayment() {
            axios.post(this.url, {}, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': 'Content-Type, Authorization'
                }})
                .then(response => { location.href = response.data.paymentUrl })
                .catch(error => {
                    console.log(error)
                    // $('#message').html(error.response.data.message)
                    // $('.remove-on-error').remove()
                });
        }
    }
}
</script>

<style scoped>

</style>
